module.exports = __webpack_public_path__ + "img/email.f54212c1.svg";